import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
import SubmitBtn from 'components/SubmitBtn'
import { isMobile } from 'helpers'

function DriverEmploymentForm() {
  const history = useHistory()
  const isMobileBrowser = isMobile()

  const [role, setRole] = useState('independent')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(true)

  const options = [
    {
      value: 'independent',
      title: 'Independent Chauffeur',
      subtitle: 'Operate my own vehicle',
    },
    {
      value: 'employed',
      title: 'Employed Chauffeur',
      subtitle: 'Drive for a chauffeur company',
    },
    {
      value: 'operator',
      title: 'Operator / Fleet Owner',
      subtitle: 'Manage multiple chauffeurs or vehicles',
    },
  ]

  const handleSubmit = e => {
    e.preventDefault()

    if (!role) {
      return
    }

    setSubmitted(true)

    fetch('https://demo.rolzo.com/pipedrive/driver-compliance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'POST',
        id: window.location.pathname.split('/')[4],
        role: role,
      }),
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
      })
      .catch(console.error)

    setTimeout(() => {
      history.push(window.location.href.replace('employment-form', 'home-page'))
    }, 3000)
  }

  useEffect(() => {
    fetch('https://demo.rolzo.com/pipedrive/driver-compliance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'GET',
        id: window.location.pathname.split('/')[4],
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.data.dataAlreadyExist) setSubmitted(true)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [])

  if (loading) return null

  return (
    <div className='driver-booking-container'>
      {submitted ? (
        <div className='partner-accepted-modal'>
          <img src={'/images/icon-partner-check.png'} width={80} alt='' />
          <h4 style={{ textAlign: 'center', margin: '16px 16px 0px 16px' }}>
            Thank you for submitting your details.
          </h4>
          <br />
          <p style={{ textAlign: 'center', margin: '-7px', padding: '16px' }}>
            Your information has been received and your profile has been updated
            successfully. ROLZO will review your information and contact you if
            any additonal detailes are required.
          </p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className='driver-employment-card-group'>
            <h4 className='driver-employment-main-title'>Compliance Review</h4>
            <h6 className='driver-employment-sub-title'>Select your role</h6>

            {options.map(option => (
              <label
                key={option.value}
                className={`driver-employment-role-card ${
                  role === option.value ? 'selected' : ''
                }`}
              >
                <input
                  type='radio'
                  name='role'
                  value={option.value}
                  checked={role === option.value}
                  onChange={e => setRole(e.target.value)}
                />

                <div className='driver-employment-role-content'>
                  <div className='driver-employment-top-row'>
                    <span className='driver-employment-custom-radio' />
                    <div className='driver-employment-role-title'>
                      {option.title}
                    </div>
                  </div>

                  <div
                    className='no-data-header'
                    style={{
                      textTransform: 'none',
                      color: 'black',
                      fontSize: '14px',
                    }}
                  >
                    {option.subtitle}
                  </div>
                </div>
              </label>
            ))}
          </div>

          <div
            className='driver-booking-cta-footer-acc'
            style={isMobileBrowser ? { left: '1px' } : {}}
          >
            <SubmitBtn title='Complete' className='select-btn select-vehicle' />
          </div>
        </form>
      )}
    </div>
  )
}

export default withRouter(connect(null, {})(DriverEmploymentForm))
